import { useState, useEffect } from "react";
import { Form, Row, Col, message, Select, Divider } from "antd";
import CustomTitle from "../../../components/CustomTitle.jsx";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useToken from "../../../common/helper/usetoken.js";
import blueStar from "../../../assets/images/BlueStar.svg";
import React from "react";
import { useSpin } from "../../../components/SpinContext.js";
import { selectLocationState } from "../../../reudx-toolkit/slice/LocationSlice";
import { useSelector } from "react-redux";
import NotificationTypeSelector from "./NotificationTypeSelector.jsx";
import NotificationTypeFields from "./NotificationTypeFields.jsx";
import NotificationMethodSection from "./NotificationMethodSection.jsx";
import FormStepFooter from "./FormStepFooter.jsx";
import {
  createShipmentNotification,
  GetSingleShipment,
  shipmentNotificationRecipient,
  updateShipmentNotification,
} from "../../../api's/shipment.js";

const ShipmentAddNotificationForm = ({
  setUsers,
  form,
  selected,
  onClose,
  shipmentId,
  notificationTypes,
  notificationPermissions,
  isEditing,
  setHoveredCardId,
  hoveredCardId,
  selectedNotificationMethod,
  setSelectedNotificationMethod,
  selectedThresholds,
  setSelectedThresholds,
  unauthorize,
  fetchNotifications,
  selectedType,
  aiMessage,
  setAiMessage,
  setSelectedType,
  step,
  setStep,
  selectedUserGroup,
  setSelectedUserGroup,
}) => {
  const { decodedUserToken, getUserID } = useToken();
  const [selectedOption, setSelectedOption] = useState(null);
  const { showSpin, hideSpin } = useSpin();
  const [teamsData, setTeamsData] = useState([]);
  const { locationList } = useSelector(selectLocationState);
  const { token } = useToken();
  const [thresholds, setThresholds] = useState({});
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [shipment,setShipment]=useState(false)
  const [isRecipientsDropdownOpen, setIsRecipientsDropdownOpen] =
    useState(false);
  useState(false);
  const loggedInUserId = getUserID();

  const createSelf = notificationPermissions?.create_self;

  const stepActions = {
    2: {
      primaryText: "Enable Notification",
      onPrimary: () => {
        form
          .validateFields()
          .then((formValues) => {
            const selectedValues = formValues.users || [];

            const sendToMap = {};

            selectedValues.forEach((val) => {
              if (val.includes("::ALL_MEMBERS")) {
                const [teamId] = val.split("::");
                sendToMap[teamId] = {
                  id: teamId,
                  users: [],
                  select_all: true,
                };
              } else {
                const [teamId, userId] = val.split("::");
                if (!sendToMap[teamId]) {
                  sendToMap[teamId] = {
                    id: teamId,
                    users: [],
                    select_all: false,
                  };
                }
                sendToMap[teamId].users.push(userId);
              }
            });

            const sendToArray = Object.entries(sendToMap).map(
              ([teamId, data]) => {
                const isAllSelected = selectedValues.includes(
                  `${teamId}::ALL_MEMBERS`
                );
                return {
                  id: teamId,
                  select_all: isAllSelected,
                  users: isAllSelected ? [] : data.users,
                  create_self: Array.isArray(teamsData)
                    ? teamsData.find((t) => t.id === teamId)?.permissions
                        ?.create_self || false
                    : false,
                };
              }
            );

            const alertTypes = selectedThresholds.reduce((acc, id) => {
              const rawValue = thresholds[id];
              const numericValue = parseFloat(rawValue);
              if (!isNaN(numericValue)) {
                acc[id] = numericValue;
              }
              return acc;
            }, {});

            const payload = {
              alert_types: alertTypes,
              alert_type: selectedType?.id,
              is_critical: false,
              is_at_risk: false,
              is_pickup_confirmation: selectedUserGroup.includes("pickup"),
              is_delivery_confirmation: selectedUserGroup.includes("delivery"),
              location: formValues.facility_type || null,
              change_by: formValues.changed_by || null,
              notification_method: selectedNotificationMethod,
              send_to: sendToArray,
              shipments: [shipmentId],
              ...(["AI_EMAIL", "AI_CALL"].includes(
                selectedNotificationMethod
              ) && {
                message: {
                  body_html: aiMessage.replace(/\n/g, "<br/>"),
                  body_text: aiMessage,
                },
              }),
            };

            console.log("Final Payload:", payload);

            showSpin();

            const apiCall = isEditing
              ? updateShipmentNotification(token, payload, selected?.id)
              : createShipmentNotification(token, payload);

            apiCall
              .then((res) => {
                const data = res?.data || {};
                if (data?.data?.is_success) {
                  onClose();
                  form.resetFields();
                  fetchNotifications();
                  setSelectedUserGroup([]);
                  message.success(data?.data?.message || "Notification saved");
                } else {
                  message.error(
                    data?.data?.message || "Failed to save notification"
                  );
                }
              })
              .catch((error) => {
                console.error("API Error:", JSON.stringify(error, null, 2));
                message.error(
                  error?.response?.data?.message ||
                    error?.message ||
                    "Notification save failed."
                );
                unauthorize(error);
              })
              .finally(() => {
                hideSpin();
              });
          })
          .catch((validationError) => {
            console.warn("Form validation failed:", validationError);
          });
      },
      cancelText: "Cancel",
      onCancel: onClose,
    },
    3: {
      primaryText: "Continue",
      onPrimary: () => setStep(2),
      cancelText: "Cancel",
      onCancel: () => setStep(2),
    },
  };

  const allowedMethodsFromToken =
    decodedUserToken()?.notification_options || "";

  const baseOptions = [
    { value: "MOBILE", label: "SMS" },
    { value: "EMAIL", label: "Email" },
    { value: "SLACK", label: "Slack" },
    { value: "TEAMS", label: "Teams" },
    { value: "WHATSAPP", label: "WhatsApp" },
  ];

  const aiOptions =
    selectedType?.id === "ETA_BASED"
      ? [
          {
            value: "AI_EMAIL",
            label: (
              <span style={{ display: "flex", alignItems: "center" }}>
                Email using AI assistant
                <img
                  src={blueStar}
                  alt="AI"
                  style={{ marginLeft: 6, width: 20, height: 20 }}
                />
              </span>
            ),
            disabled: false,
          },
          {
            value: "AI_CALL",
            label: (
              <span style={{ display: "flex", alignItems: "center" }}>
                Call using AI assistant
                <img
                  src={blueStar}
                  alt="AI"
                  style={{ marginLeft: 6, width: 20, height: 20 }}
                />
              </span>
            ),
            disabled: !allowedMethodsFromToken.includes("MOBILE"),
          },
        ]
      : [];

  const notificationOptions = [
    ...baseOptions.map((opt) => ({
      ...opt,
      disabled:
        !["EMAIL", "SLACK", "TEAMS"].includes(opt.value) &&
        !allowedMethodsFromToken.includes(opt.value),
    })),
    ...aiOptions,
  ];

  const handleTypeSelect = (id) => {
    const selected = notificationTypes.find((t) => t.id === id);
    setSelectedType(selected);
    setStep(2);
  };

  useEffect(() => {
    if (isEditing && selected?.id && teamsData.length > 0) {
      const internalValues = [];
      const visibleValues = [];

      selected.send_to?.forEach((team) => {
        const teamId = team.id;
        const teamData = teamsData.find((t) => t.id === teamId);
        const allUserIds = (teamData?.users || []).map(
          (u) => `${teamId}::${u.id}`
        );

        if (team.select_all) {
          // ✅ Internally select all users + all_members
          internalValues.push(...allUserIds, `${teamId}::ALL_MEMBERS`);
          // ✅ Show only ALL_MEMBERS in visible tags
          visibleValues.push(`${teamId}::ALL_MEMBERS`);
        } else {
          // ✅ Show and store each selected user
          (team.users || []).forEach((user) => {
            const userId = typeof user === "string" ? user : user.id;
            const val = `${teamId}::${userId}`;
            internalValues.push(val);
            visibleValues.push(val);
          });
        }
      });
      form.setFieldsValue({
        users: [...new Set(internalValues)],
        notification_method: selected?.notification_method,
        facility_type: selected?.location,
        changed_by: selected?.change_by,
      });
      setSelectedNotificationMethod(selected?.notification_method);

      setTimeout(() => {
        form.setFieldsValue({ users: [...new Set(visibleValues)] });
      }, 0);
      const updatedGroups = [];
      if (selected.is_pickup_confirmation) updatedGroups.push("pickup");
      if (selected.is_delivery_confirmation) updatedGroups.push("delivery");
      setSelectedUserGroup(updatedGroups);

      if (selected?.alert_types) {
        const thresholdIds = Object.keys(selected.alert_types);
        setSelectedThresholds(thresholdIds);
        setThresholds(selected.alert_types);
      }
    }
  }, [isEditing, selected, teamsData]);

  useEffect(() => {
    shipmentNotificationRecipient(token, shipmentId)
      .then((res) => {
        const teamList = res?.data?.data?.data || [];
        setTeamsData(teamList);
        const allUsers = teamList.flatMap((team) =>
          team.users.map((user) => ({
            ...user,
            company_user_id: user.id,
          }))
        );
        setUsers(allUsers);
        const options = teamList.map((team) => ({
          id: team.id,
          name: team.name,
          permissions: team.permissions || {},
          users: team.users || [],
        }));
        setTeamsOptions(options);
      })
      .catch((error) => {
        unauthorize(error);
      });
  }, [shipmentId, token]);

   const fetchSingleShipmentData = () => {
      showSpin();
      GetSingleShipment(token, shipmentId, false)
        .then((res) => {
          const data = res?.data ? res.data : null;
          if (data) {
            if (data?.data?.is_success) {
              let resp = data?.data?.data ? data?.data?.data : null;
              if (resp) {
                setShipment(resp);
          
              }
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };
  



  useEffect(() => {
  fetchSingleShipmentData()
  }, [])
  
  return (
    <Form
      className="custom-form form-item"
      form={form}
      layout="vertical"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {step === 1 && (
        <div
          style={{
            position: "absolute",
            paddingTop: "0px",
            left: "0",
            padding: "0px 24px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={
              !isEditing
                ? "Add shipment notification"
                : "Edit shipment notification"
            }
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>
      )}

      {step !== 1 && !isEditing && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            marginBottom: "12px",
          }}
          onClick={() => {
            setSelectedNotificationMethod(null);
            setSelectedThresholds([]);
            setSelectedUserGroup([]);
            form.resetFields();
            setStep((prev) => Math.max(prev - 1, 1));
          }}
        >
          <ArrowLeftOutlined
            style={{
              fontSize: "14px",
              color: "#000",
              marginRight: "8px",
            }}
          />
        </div>
      )}
      <div
        style={{
          flex: 1,
          paddingTop: step === 1 ? "48px" : "0px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="custom-scrollbar"
      >
        {step === 1 && !isEditing ? (
          <NotificationTypeSelector
            notificationTypes={notificationTypes}
            selectedType={selectedType}
            onSelect={handleTypeSelect}
            hoveredCardId={hoveredCardId}
            setHoveredCardId={setHoveredCardId}
          />
        ) : (
          <>
            {step !== 1 && selectedType && (
              <div className="custom-card-shipment">
                <NotificationTypeFields
                shipment={shipment}
                  thresholds={thresholds}
                  setThresholds={setThresholds}
                  selectedType={selectedType}
                  step={step}
                  setStep={setStep}
                  selectedThresholds={selectedThresholds}
                  setSelectedThresholds={setSelectedThresholds}
                  selectedUserGroup={selectedUserGroup}
                  setSelectedUserGroup={setSelectedUserGroup}
                  locationList={locationList}
                />
              </div>
            )}

            {step === 2 && (
              <>
                <Divider
                  style={{
                    marginTop:
                      selectedType?.id === "PICKUP_DELIVERY" ? "20px" : "12px",
                    marginBottom: "18px",
                    borderColor: "#E2E2E2",
                  }}
                />

                <Row style={{ width: "100%" }} gap={16}>
                  <NotificationMethodSection
                    isEditing={isEditing}
                    aiMessage={aiMessage}
                    selected={selected}
                    setAiMessage={setAiMessage}
                    form={form}
                    notificationOptions={notificationOptions}
                    selectedNotificationMethod={selectedNotificationMethod}
                    setSelectedNotificationMethod={
                      setSelectedNotificationMethod
                    }
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    createSelf={createSelf}
                  />
                </Row>

                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style custom-select-disabled-only"
                    label="Recipients"
                    name="users"
                    rules={[
                      {
                        required: true,
                        message: "Please select at least one recipient",
                      },
                    ]}
                    style={{ marginBottom: "0px" }}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select..."
                      optionLabelProp="label"
                      onChange={(values) => {
                        const lastValue = values[values.length - 1];

                        if (lastValue?.includes("::ALL_MEMBERS")) {
                          const [teamId] = lastValue.split("::");

                          const selectedNotifyVia = form.getFieldValue(
                            "notification_method"
                          );
                          const currentUserId = loggedInUserId;

                          const team = teamsData.find((t) => t.id === teamId);
                          if (team) {
                            const validUserIds = team.users
                              .filter((user) => {
                                const notifyOptionIsFalse =
                                  selectedNotifyVia &&
                                  user.notification_options?.[
                                    selectedNotifyVia
                                  ] === false;

                                const isDisabled =
                                  notifyOptionIsFalse ||
                                  (team.permissions.create_self &&
                                    user.id !== currentUserId);

                                return !isDisabled;
                              })
                              .map((user) => `${teamId}::${user.id}`);
                            const updatedValues = [
                              ...values.filter(
                                (v) =>
                                  !v.startsWith(`${teamId}::`) ||
                                  v === `${teamId}::ALL_MEMBERS`
                              ),
                              ...validUserIds,
                            ];
                            const cleanValues = updatedValues.filter(
                              (v) => !v.startsWith(`${teamId}::`)
                            );
                            cleanValues.push(`${teamId}::ALL_MEMBERS`);

                            form.setFieldsValue({
                              users: [...new Set(updatedValues)],
                            });
                            setTimeout(() => {
                              const allSelectedValues =
                                form.getFieldValue("users") || [];
                              const badgeOnlyValues = allSelectedValues.filter(
                                (val) => val.includes("::ALL_MEMBERS")
                              );
                              form.setFieldsValue({ users: badgeOnlyValues });
                            }, 0);
                          }
                        } else {
                          const allTeamsWithAllMembers = new Set(
                            values
                              .filter((v) => v.includes("::ALL_MEMBERS"))
                              .map((v) => v.split("::")[0])
                          );

                          const cleanedValues = values.filter((v) => {
                            if (v.includes("::ALL_MEMBERS")) return true;
                            const [teamId] = v.split("::");
                            return !allTeamsWithAllMembers.has(teamId);
                          });

                          form.setFieldsValue({ users: cleanedValues });
                        }
                      }}
                      className="custom-optgroup-label"
                      open={isRecipientsDropdownOpen}
                      onDropdownVisibleChange={(open) => {
                        const hasNotifyVia = !!form.getFieldValue(
                          "notification_method"
                        );
                        if (open) {
                          if (hasNotifyVia) {
                            setIsRecipientsDropdownOpen(true);
                          } else {
                            message.error("Please select 'Notify via' first.");
                            setIsRecipientsDropdownOpen(false);
                          }
                        } else {
                          setIsRecipientsDropdownOpen(false);
                        }
                      }}
                      tagRender={({ label, value, closable, onClose }) => (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "0px 8px",
                            background: "#5E5E5E",
                            borderRadius: "8px",
                            marginRight: "4px",
                            color: "white",
                            fontSize: "10px",
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>{label}</span>
                          {closable && (
                            <span
                              onClick={onClose}
                              style={{
                                marginLeft: 6,
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "14px",
                              }}
                            >
                              ×
                            </span>
                          )}
                        </div>
                      )}
                      dropdownRender={(menu) => (
                        <div
                          className="custom-optgroup-label no-scrollbar"
                          style={{ maxHeight: 250, overflowY: "auto" }}
                        >
                          {menu}
                        </div>
                      )}
                      style={{
                        border: "0px",
                        backgroundColor: "#F3F3F3",
                        minHeight: "36px",
                        borderRadius: "8px",
                        width: "100%",
                      }}
                    >
                      {teamsData.map(({ id, name, users, permissions }) => (
                        <React.Fragment key={id}>
                          {/* Only render "All members of..." if more than one team or team name is not "Default" */}
                          {!(
                            teamsData.length === 1 &&
                            name.toLowerCase() === "default"
                          ) && (
                            <Select.Option
                              key={`${id}::ALL_MEMBERS`}
                              value={`${id}::ALL_MEMBERS`}
                              label={`All members of ${name}`}
                              disabled={!permissions.is_create}
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#FAFAFA",
                                color: !permissions.is_create
                                  ? "#B0B0B0"
                                  : "#333",
                                paddingLeft: "16px",
                                borderBottom: "1px solid #E8E8E8",
                              }}
                            >
                              All members of {name}
                            </Select.Option>
                          )}

                          {users.map((user) => {
                            const selectedNotifyVia = form.getFieldValue(
                              "notification_method"
                            );
                            const currentUserId = loggedInUserId;

                            const notifyOptionIsFalse =
                              selectedNotifyVia &&
                              user.notification_options?.[selectedNotifyVia] ===
                                false;

                            const isDisabled =
                              notifyOptionIsFalse ||
                              (permissions.create_self &&
                                user.id !== currentUserId);

                            return (
                              <Select.Option
                                key={`${id}::${user.id}`}
                                value={`${id}::${user.id}`}
                                label={user.name || user.email || user.id}
                                disabled={isDisabled}
                                style={{
                                  color: isDisabled ? "#B0B0B0" : "#000",
                                  fontSize: "14px",
                                  paddingLeft: "16px",
                                }}
                              >
                                {user.name || user.email || user.id}
                              </Select.Option>
                            );
                          })}
                        </React.Fragment>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </>
            )}
          </>
        )}
        <FormStepFooter step={step} stepActions={stepActions} />
      </div>
    </Form>
  );
};

export default ShipmentAddNotificationForm;
